<div class="table__container">
  <ng-container *ngIf="(elements.length > 0); else blankSlateObserverTable">
    <table class="table table-border round-corner">
      <thead>
        <tr>
          <th scope="col" class="text-center" width="45" [ngSwitch]="headerCheckboxState"
            (click)="onHeaderCheckboxChange()">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngSwitchCase="checkboxState.Unchecked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngSwitchCase="checkboxState.Checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','minus-square']"
              *ngSwitchCase="checkboxState.Indeterminate"></fa-icon>
          </th>
          <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
          <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of elements; let i = index" class="cursor" (click)="onCheckboxClick(element)">
          <td width="10%" class="text-center text-overflow-none">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngIf="!element.checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngIf="element.checked"></fa-icon>
          </td>
          <td width="30%" class="text-truncate text-left">{{element.name}}</td>
          <td width="20%" class="text-truncate text-left">{{element.mail}}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<ng-template #blankSlateObserverTable>
  <cdx-blankslate [options]="blankslateOptions" (buttonClick)="onBlankSlateButtonClick($event)">
    {{ 'envelope.observer.modalAdd.noObserversFounded' | translate }}
  </cdx-blankslate>
</ng-template>
